import React, { Component } from "react";
import PropTypes from 'prop-types';
import VideoStream from './video_stream';
import Worker from './qr_decode.worker.js';

const wrapperStyles = {
  height: '100%',
  width: '100%',
  overflow: 'hidden'
};

class ReactiveQR extends Component {
  worker = null;

  componentWillMount() {
    this.worker = new Worker();
    this.worker.addEventListener('message', this.onFrameDecoded);
  }

  componentWillUnmount() {
    if (this.worker !== null) {
      this.worker.terminate();
      this.worker = null;
    }
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    try {
      var overlaySize = this.getOverlayDimensions(this.div.offsetWidth, this.div.offsetHeight);
      this.drawOverlay(overlaySize);
    } catch(e) {
      console.log(e);
    }
  }

  onVideoStreamInit = (state, drawFrame) => {
    this.handleResize();
    if (this.props.onInit) {
      this.props.onInit(state);
    }
    this.drawVideoFrame = drawFrame;

    if (this.props.shouldDecode) {
      this.drawVideoFrame();
    }
  }

  getOverlayDimensions = (width, height) => {
    var minLength = Math.min(width, height);
    var paddingHeight = (height + 64 - minLength) / 2;
    var paddingWidth = (width + 64 - minLength) / 2;

    return {
      minLength: minLength,
      width: minLength - 64,
      height: minLength - 64,
      paddingHeight: paddingHeight,
      paddingWidth: paddingWidth
    };
  };

  drawOverlay = (overlayDimensions) => {
    var boxPaddingHeightSize = overlayDimensions.paddingHeight;
    var boxPaddingWidthSize = overlayDimensions.paddingWidth;
    this.overlay.style.borderTopWidth = boxPaddingHeightSize + "px";
    this.overlay.style.borderLeftWidth = boxPaddingWidthSize + "px";
    this.overlay.style.borderRightWidth = boxPaddingWidthSize + "px";
    this.overlay.style.borderBottomWidth = boxPaddingHeightSize + "px";
  };

  onFrame = (frameData) => this.worker.postMessage(frameData);
  drawVideoFrame = () => { }

  onFrameDecoded = (event) => {
    const code = event.data;
    if (code) {
      const { data } = code;
      if (this.props.onCode && data.length > 0) {
        this.props.onCode(code);
      }
    }

    if (this.props.shouldDecode) {
      this.drawVideoFrame();
    }
  };

  render() {
    return (
      <div className={this.props.className} style={{ ...wrapperStyles, ...this.props.style }}  ref={d => (this.div = d)}>
        <VideoStream
          onFrame={this.onFrame}
          onInit={this.onVideoStreamInit}
          style={this.props.videoStyle}
        />
        <div className="Camera-overlay" ref={o => (this.overlay = o)}></div>
      </div>
    );
  }
}

ReactiveQR.propTypes = {
  onInit: PropTypes.func,
  shouldDecode: PropTypes.bool,
  onCode: PropTypes.func,
  style: PropTypes.object,
  videoStyle: PropTypes.object,
  rearCamera: PropTypes.bool,
  className: PropTypes.string,
};

ReactiveQR.defaultProps = {
  onInit: () => { },
  shouldDecode: true,
  onCode: () => { },
  style: {},
  videoStyle: {},
  rearCamera: true,
  className: undefined,
};

export default ReactiveQR;


// WEBPACK FOOTER //
// ./src/components/ReactiveQR/index.js